import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import PaginationActions from 'components/Utility/PaginationActions';
import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import '../index.scss';
import PendingBookingsTableHead from './PendingBookingsTableHead';
import PendingBookingsTableRow from './PendingBookingsTableRow';

class PendingBookingsTable extends React.Component {
  state = {
    rowsPerPage: 10,
    page: 0,
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  render() {
    const venue = this.props.venue;

    const { rowsPerPage, page } = this.state;
    const limitedBookings = (this.props.pendingBookingList || []).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    return (
      <div>
        <Table>
          <PendingBookingsTableHead venue={venue} />
          <TableBody>
            {limitedBookings.map(booking => {
              const boundBookingModal = this.props.showBookingModal.bind(
                this,
                booking
              );
              return (
                <PendingBookingsTableRow
                  remindPendingBooking={this.props.remindPendingBooking}
                  onClick={boundBookingModal}
                  key={`p-${booking.id}`}
                  venue={venue}
                  booking={booking}
                />
              );
            })}
          </TableBody>

          <TableFooter>
            <TableRow>
              <TablePagination
                className="table__pagination"
                colSpan={4}
                count={this.props.pendingBookingList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                ActionsComponent={PaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>

        <Loader loading={this.props.loading} />
      </div>
    );
  }
}

PendingBookingsTable.propTypes = {
  showBookingModal: PropTypes.func.isRequired,
  venue: PropTypes.object.isRequired,
  pendingBookingList: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  remindPendingBooking: PropTypes.func.isRequired,
};

export default PendingBookingsTable;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/PendingBookingsTable/index.jsx